import { render, staticRenderFns } from "./OrderFlowDeliveryPage.vue?vue&type=template&id=0b4f9149&scoped=true"
import script from "./OrderFlowDeliveryPage.vue?vue&type=script&lang=js"
export * from "./OrderFlowDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f9149",
  null
  
)

export default component.exports